import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { appService } from '../../../../app/_services/app.service';
import { OrdersService } from '../../services/orders/orders.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { CommonService } from '../../services/commen/commen.services';
import { Helpers } from '../../../../app/helpers';

@Component({
  selector: 'app-download-via-inputs',
  templateUrl: './download-via-inputs.component.html',
  styleUrls: ['./download-via-inputs.component.scss']
})
export class DownloadViaInputsComponent implements OnInit {

  CompanyId: any;
  userId: any;
  TenantId: any;
  data: any = {};
  @Output() onCloseEvent = new EventEmitter<any>();
  @Input() IsSaveDisable: any = false;
  isFormSubmit: boolean = false;
  modalRef: any;

  BankName: any = {
    lable: 'Bank Name',
    formControlName: 'BankName',
    dataField: 'BankName',
    isRequired: true,
    isSearchByApi: true,
    placeholder: 'Select Bank Name',
    typeOfField: 'dropdown',
    isValueBind: true
  };
  Code = {
    lable: 'Code',
    formControlName: 'Code',
    dataField: 'Code',
    isRequired: true,
    placeholder: 'Enter Code',
  };
  FromDate = {
    lable: 'From Date',
    formControlName: 'FromDate',
    dataField: 'FromDate',
    isRequired: false,
    placeholder: 'Select From Date',
  };
  ToDate = {
    lable: 'To Date',
    formControlName: 'ToDate',
    dataField: 'ToDate',
    isRequired: false,
    placeholder: 'Select To Date',
  };

  isMobileView: any;

  constructor(
    private _appService: appService,
    private orderService: OrdersService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private translate: TranslateService,
    private decryptpipe: DecryptPipe,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.TenantId = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).TenantId;
  }

  searchStatusOnField(data, Status) {
    data.isSearch = Status;
  }

  GetBankName(value, isScrollDown = false) {
    this.BankName.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.BankName.dropdownList.length / 20) + 1;
    }
    this.orderService.GetBankName(value, pageNo, this.CompanyId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.BankName.dropdownList.length) {
        dropdownList = dropdownList.concat(this.BankName.dropdownList);
        this.BankName = { ...this.BankName, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.BankName = { ...this.BankName, dropdownList: [...dropdownList] });
      this.BankName.isSearch = false;
    },
    (err) => {
      this.BankName.isSearch = false;
    })
  }

  getDropdownList(value, data) {
    if (data.dataField === 'BankName') {
      this.searchStatusOnField(data, true);
      this.GetBankName(value, false)
    }
  }

  findObjectOfTheFieldV2(data, dropdownList) {
    data.dropdownList = dropdownList;
    data.isSearch = false;
    if (data.dataField) {
      data.isReadOnly = false
    }
  }

  getChangedValue(value, data) {
    if (data.dataField == 'BankName') {
      this.data[data.dataField] = value.value;
    } else if (data.dataField == 'VehicleNo') {
      this.data[data.dataField] = value.value;
    } else if (data.dataField == 'Driver') {
      this.data[data.dataField] = value.value;
      this.data.DriverMobileNo = value.MobileNo;
    } else {
      this.data[data.dataField] = value;
    }
  }

  close() {
    this.onCloseEvent.emit();
  }

  ValidateData() {
    var IsAllDataDone: any = true;
    if (!this.data.BankName) {
      IsAllDataDone = false;
    }
    if (!this.data.Code) {
      IsAllDataDone = false;
    }
    if (!IsAllDataDone) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.error(RequiredError, "error");
    }
    return IsAllDataDone;
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

  download(){
    this.isFormSubmit = true;
    if (this.ValidateData()) {
      console.log('data', this.data)
      this._appService.GetByFiveId("BillPayment", "GetPaymentAdviceDownloadData", this.CompanyId, this.data.BankName, this.data.FromDate, this.data.ToDate, this.data.Code).subscribe((response) => {
        this.DownloadFile(response);
        Helpers.setLoading(false);
        this.close();
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error(
          this.translate.instant("User.ErrorMessage"),
          "error"
        );
      }
    );
    }
  }

}
